// Unicode code points for the digit "0" in various numeral systems, such as:
// Arabic-Indic ,Extended Arabic-Indic ,Devanagari ,Bengali ,Gurmukhi ,Gujarati ,Tamil ,Telugu ,Kannada ,Malayalam ,Thai ,Lao ,Tibetan ,Myanmar ,Khmer ,Mongolian ,Limbu ,New Tai Lue ,Tai Tham Hora ,Tai Tham Tham ,Balinese ,Sundanese ,Lepcha ,Ol Chiki ,Vai ,Saurashtra ,Kayah Li ,Javanese ,Cham ,Meetei Mayek, Fullwidth (used in Chinese, Japanese, Korean)
const ZERO_POINTS: readonly number[] = [
  0x0660, 0x06f0, 0x0966, 0x09e6, 0x0a66, 0x0ae6, 0x0be6, 0x0c66, 0x0ce6, 0x0d66, 0x0e50, 0x0ed0, 0x0f20, 0x1040,
  0x17e0, 0x1810, 0x1946, 0x19d0, 0x1a80, 0x1a90, 0x1b50, 0x1bb0, 0x1c40, 0x1c50, 0xa620, 0xa8d0, 0xa900, 0xa9d0,
  0xaa50, 0xabf0, 0xff10,
]

// Matches all supported Unicode digit characters
const DIGIT_REGEX: RegExp =
  /[\u0660-\u0669\u06f0-\u06f9\u0966-\u096f\u09e6-\u09ef\u0a66-\u0a6f\u0ae6-\u0aef\u0be6-\u0bef\u0c66-\u0c6f\u0ce6-\u0cef\u0d66-\u0d6f\u0e50-\u0e59\u0ed0-\u0ed9\u0f20-\u0f29\u1040-\u1049\u17e0-\u17e9\u1810-\u1819\u1946-\u194f\u19d0-\u19d9\u1a80-\u1a89\u1a90-\u1a99\u1b50-\u1b59\u1bb0-\u1bb9\u1c40-\u1c49\u1c50-\u1c59\ua620-\ua629\ua8d0-\ua8d9\ua900-\ua909\ua9d0-\ua9d9\uaa50-\uaa59\uabf0-\uabf9\uff10-\uff19]/g

// Lazily initialized lookup table
let DIGIT_MAP: Readonly<Record<number, string>> | null = null

function getDigitMap(): Readonly<Record<number, string>> {
  if (DIGIT_MAP) {
    return DIGIT_MAP
  }

  const map: Record<number, string> = {}

  for (const start of ZERO_POINTS) {
    for (let i = 0; i <= 9; i++) {
      map[start + i] = String(i)
    }
  }

  DIGIT_MAP = Object.freeze(map)
  return DIGIT_MAP
}

/**
 * Normalizes all Unicode digits to ASCII digits (0–9).
 *
 * @example
 * normalizeDigits('۱۲۳۴۵') // '12345'
 */
export function normalizeDigits(input: string = ''): string {
  if (!input) {
    return input
  }

  const map = getDigitMap()

  return input.replace(DIGIT_REGEX, (ch: string): string => {
    return map[ch.charCodeAt(0)] ?? ch
  })
}
